import React, {PropTypes} from 'react';
import classNames from 'classnames';
import Submitting from 'shared/Submitting.jsx';
import StandardField from 'shared/StandardField.jsx';
import StandardCheckboxField from 'shared/StandardCheckboxField.jsx';
import DisplayIf from 'shared/DisplayIf.jsx';
import {Field} from 'redux-form';
import moment from 'moment';

const EntryRosterList = ({
  sourceQty,
  source,
  bowlers,
  parentEntryId,
  childVirtualEntryEvents,
  eventIsLinked,
  childTeamOwnedVirtualEntries,
  rosterCheckout,
  showCalculatedDivisionToCaptain,
  onCartRoster,
  onSearch,
  onSearchChange,
  onAvgChange,
  onSearchEnterKeyPress,
  onIsProfessionalChange,
  onMoveUpClick,
  onMoveDownClick,
  onRosterPositionCleared,
  onAssignChildTeamOwnedVirtualEventClick
}) => (
  <div className="contact-card-wrapper">
  {source.map((roster, rosterIndex) => {
        let modifiedWithValue = roster._searchChanged &&
          (roster._searchValue !== roster.bowler.usbcId) && 
          !roster.usbcIdError;

        if (roster._searchValue === "" && !roster.bowler.usbcId) modifiedWithValue = false;

        let retrievedAndUnmodified = (!modifiedWithValue) && roster._retrieved && !roster.usbcIdError;
        let notRetrievedAndUnmodified = (!modifiedWithValue) && !roster._retrieved && !roster.usbcIdError;
        
        return (<div
        className="contact-card"
        key={rosterIndex}
      >
        <div className="contact-card-info-wrapper">
          <div className="flex direction-column vertical-center">
            {
              sourceQty > 1
              ? <button
                  className="btn-move-up"
                  disabled={rosterIndex === 0}
                  type="button"
                  onClick={() => onMoveUpClick(rosterIndex)}
                >
                  <i className="fa fa-chevron-up" />
                </button>
              : null
            }
            <div className={classNames(
                'contact-card-avatar',
                {'empty': !roster._retrieved}
              )}
            >{rosterIndex + 1}</div>
            {
              sourceQty > 1
              ? <button
                  className="btn-move-down"
                  disabled={rosterIndex === sourceQty - 1}
                  type="button"
                  onClick={() => onMoveDownClick(rosterIndex)}
                >
                  <i className="fa fa-chevron-down" />
                </button>
              : null
            }
          </div>
          <div className="contact-card-info row">
            <div className="col-lg-7 col-xs-12">
              <div className="row">
                <div className="col-xs-8">
                  <div className="form-group">
                    <span className="input-group-addon">{`Member ID `}<small>{'(###-###)'}</small></span>
                    <input
                        name={`usbcId-${roster.position}`}
                        className="form-control"
                        type="text"
                        placeholder="(ie. 1234-1234)"
                        pattern="^\d+(-\d+)$"
                        value={roster._searchValue}
                        onChange={event => onSearchChange(roster, event)}
                        onKeyDown={event => onSearchEnterKeyPress(roster, event)}
                        onInput={event => onSearchChange(roster, event)}
                        list={`usbcbowlers-${roster.position}`}
                      />
                    <datalist id={`usbcbowlers-${roster.position}`}>
                      {bowlers.map((b, index) => (                        
                        source.find(x => x.bowler.id == b.id) ? null :
                        <option key={index}
                          value={b.memberId}>{b.name}</option>
                      ))}
                    </datalist>
                    <button
                      type="button"
                      className={classNames(
                        'btn',
                        { 'btn-primary': retrievedAndUnmodified },
                        { 'btn-primary-brand': notRetrievedAndUnmodified },
                        { 'btn-warning': modifiedWithValue },
                        { 'btn-danger': roster.usbcIdError }
                      )}
                      disabled={roster._processing}
                      onClick={() => onSearch(roster)}
                    >{roster._processing
                      ? <Submitting />
                      : retrievedAndUnmodified
                        ? <i className="fa fa-check" />
                        : <i className="fa fa-plus" />}
                      </button>
                      { roster._errorMessage ? <button
                        type="button"
                        className="btn btn-link"
                        style={{marginLeft: 0, paddingTop: 0, paddingBottom: 0}}
                        onClick={() => onRosterPositionCleared(rosterIndex)}
                      >{'Clear Position'}</button> : null }
                  </div>
                </div>
                <div className="col-xs-4"> 
                  {
                    roster.averageRequired &&  roster._retrieved
                    ? <div className="form-group">
                        <span
                          className="input-group-addon avg">{`AVG`}</span>
                        <Field 
                          name={`average-${roster.position}`}
                          disabled={roster.bowler.readOnly}
                          className="form-control"
                          required={roster.averageRequired}
                          onCustomChange={event => onAvgChange(roster.position, event.target.value)}
                          component={StandardField}
                          style={{width: 60}}
                        />
                      </div>
                  : null}
                </div>
              </div>
              { roster.usbcIdError ? <div className="roster-notification"> Click the plus button or clear the member ID </div> : null }
              
              <div className="row">
                <div className="col-xs-8">
                  <span>{roster.bowler.firstName} {roster.bowler.initial ? roster.bowler.initial : ''} {roster.bowler.lastName} {roster.bowler.lineage ? roster.bowler.lineage : ''}</span>
                  {
                    roster._retrieved
                    ? <button
                      type="button"
                      className="btn btn-link"
                      style={{marginLeft: 20, paddingTop: 0, paddingBottom: 0}}
                      onClick={() => onRosterPositionCleared(rosterIndex)}
                      >{'Clear Position'}</button>
                    : null
                  }
                </div>
                <div className="col-xs-4">
                  {roster.bowler.gender
                    ? <div>{`Gender: ${roster.bowler.gender}`}</div>
                    : null
                  }
                </div>
              </div>
              <div className="row">
                <div className="col-xs-8">
                  {roster.bowler.city && roster.bowler.state && roster.bowler.zip
                    ? <div>{roster.bowler.city}, {roster.bowler.state} {roster.bowler.zip}</div>
                    : null
                  }
                </div>
                <div className="col-xs-4">
                  {roster.bowler.birthDate
                    ? <div>{`Age: ${moment().diff(roster.bowler.birthDate, 'years')}`}</div>
                    : null
                  }
                </div>
              </div>
              <div className="row">
                <div className="col-xs-8">
                  {
                    roster._retrieved
                    ? <div className="checkbox">
                        <label>
                          <input
                            name={`isProfessional-${roster.position}`}
                            type="checkbox"
                            disabled={roster.bowler.readOnly}
                            checked={roster.bowler.isProfessional}
                            onChange={event => onIsProfessionalChange(roster.position, event.target.checked)}
                          /> {`This bowler is a Pro`}
                        </label>
                      </div>
                    : null
                  }
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12">
                  {roster._errorMessage
                    ? <div className="roster-notification">{roster._errorMessage}</div>
                    : null
                  }
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12">
                  {roster.bowler.isOnOtherRosters
                    ? <div className="roster-notification">Warning: this bowler is already on other rosters for this event</div>
                    : null
                  }
                </div>
              </div>
            </div>
            <div className="col-lg-5 col-xs-12">
              {childVirtualEntryEvents && childVirtualEntryEvents.length > 0 ?
                childVirtualEntryEvents.map((virtualEvent, eventIndex) => {
                  let entry = childTeamOwnedVirtualEntries.find(entry => (entry.parentTeamEntryId == parentEntryId) && (entry.rosterPosition == roster.position) && (entry.virtualEventName == virtualEvent.name));
                  let entryAssigned = entry ? true : false;
                  let remaining = rosterCheckout 
                  ? childTeamOwnedVirtualEntries.filter(entry => entry.virtualEventName === virtualEvent.name && !entry.isPurchased && entry.parentTeamEntryId == null).length 
                  : virtualEvent.remaining;
                  
                  return (
                  <div className="row" 
                    key={eventIndex}>
                    <div className="col-xs-12">
                      <Field
                        id={`assignChildVirtualEntry${rosterIndex}-${eventIndex}`}
                        name={`assignChildVirtualEntry${rosterIndex}-${eventIndex}`}
                        checked={entryAssigned}
                        disabled={(rosterCheckout && !onCartRoster && entryAssigned && (entry ? entry.isPurchased: true)) || (!entryAssigned && virtualEvent.remaining == 0)}
                        component={StandardCheckboxField}
                        label={`Assign ${virtualEvent.name} (${rosterCheckout && !onCartRoster && entryAssigned && (entry ? entry.isPurchased: true) ? `already assigned` : `${remaining} remaining`})`}
                        title={rosterCheckout && !onCartRoster && entryAssigned ? `This virtual event is already assigned to this entry. Its assignment can be changed on the Manage page after checkout.` : null}
                        onCustomChange={(event) => onAssignChildTeamOwnedVirtualEventClick(virtualEvent.name, parentEntryId, rosterIndex + 1, event.target.checked)}
                      />
                    </div>
                  </div>
                );})
              : null
              }
              <DisplayIf condition={showCalculatedDivisionToCaptain && eventIsLinked}>
                <div className="row">
                  <label>{'Division'}</label>
                  <div>{!roster.bowler ? 
                          '-' : 
                          !roster.divisionName ? 
                          'Not Assigned' : 
                          <p>{roster.divisionName}</p>}
                  </div>
                </div>
              </DisplayIf>
            </div>
          </div>
        </div>
      </div>
    );
  })}
  {
      source.filter(r => {return r.bowler.isProfessional;}).length > 1
      ? <div className="roster-notification">Warning: There is more than one professional bowler on this roster</div>
      : null
    }
  </div>
);

EntryRosterList.propTypes = {
  sourceQty: PropTypes.number,
  source: PropTypes.arrayOf(PropTypes.object),
  bowlers: PropTypes.arrayOf(PropTypes.object),
  parentEntryId: PropTypes.string,
  childVirtualEntryEvents: PropTypes.arrayOf(PropTypes.object),
  eventIsLinked: PropTypes.bool,
  childTeamOwnedVirtualEntries: PropTypes.arrayOf(PropTypes.object),
  rosterCheckout: PropTypes.bool,
  showCalculatedDivisionToCaptain: PropTypes.bool,
  onCartRoster: PropTypes.bool,
  onSearch: PropTypes.func,
  onSearchChange: PropTypes.func,
  onSearchEnterKeyPress: PropTypes.func,
  onIsProfessionalChange: PropTypes.func,
  onAvgChange: PropTypes.func,
  onMoveUpClick: PropTypes.func,
  onMoveDownClick: PropTypes.func,
  onRosterPositionCleared: PropTypes.func,
  onAssignChildTeamOwnedVirtualEventClick: PropTypes.func
};

EntryRosterList.defaultProps = {
  bowlers: [],
  rosterCheckout: window.location.href.indexOf("rostercheckout") >= 0,
  onCartRoster: false
};

export default EntryRosterList;



// WEBPACK FOOTER //
// ./src/features/shared/EntryRosterList.jsx